import {BrowserRouter, Route} from "react-router-dom";
import {
    Header,
    Landing
} from './';
import {useEffect} from "react";
import {useDispatch} from "react-redux";
import * as actions from './../store/actions';
import {SURVEY_NEW_URL, SURVEYS_URL} from "../constants";

const Dashboard = () => <h2>Dashboard</h2>;
const SurveyNew = () => <h2>SurveyNew</h2>;

const App = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.fetchUser());
    }, []);

    return (
        <div className="container">
            <BrowserRouter>
                <div>
                    <Header/>
                    <Route exact path={"/"} component={Landing}/>
                    <Route exact path={SURVEYS_URL} component={Dashboard}/>
                    <Route path={SURVEY_NEW_URL} component={SurveyNew}/>
                </div>
            </BrowserRouter>
        </div>
    );
};

export default App;